// extracted by mini-css-extract-plugin
export default {"userNameCell":"userNameCell__9oA3X"};